const loadingPage = {
  key: 'loadingPage',
  name: 'LoadingPage',
  icon: '',
};
export default loadingPage;
